import "/__w/1/s/BotFramework-WebChat/packages/component/src/Activity/CollapsibleContent.module_built.css";
const classes = {"collapsible-content__chevron":"wo1OXYa_collapsible-content__chevron","collapsible-content__summary-text":"wo1OXYa_collapsible-content__summary-text","collapsible-content__content":"wo1OXYa_collapsible-content__content","collapsible-content__summary":"wo1OXYa_collapsible-content__summary","collapsible-content":"wo1OXYa_collapsible-content"}
export default classes

const _collapsible_content__chevron0 = classes["collapsible-content__chevron"]
export { _collapsible_content__chevron0 as "collapsible-content__chevron" }

const _collapsible_content__summary_text0 = classes["collapsible-content__summary-text"]
export { _collapsible_content__summary_text0 as "collapsible-content__summary-text" }

const _collapsible_content__content0 = classes["collapsible-content__content"]
export { _collapsible_content__content0 as "collapsible-content__content" }

const _collapsible_content__summary0 = classes["collapsible-content__summary"]
export { _collapsible_content__summary0 as "collapsible-content__summary" }

const _collapsible_content0 = classes["collapsible-content"]
export { _collapsible_content0 as "collapsible-content" }
